import { useParams } from "react-router";
import { RefActivity } from "../../../../api/hooks";
import ActivityView from "../../../../common/activity/ActivityView";

const EquipmentStockAdjustmentActivity = () => {
    const { stockAdjustmentId } = useParams<any>();
    return (
        <div>
            {stockAdjustmentId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.EquipmentStockAdjustment}
                    activityRefId={stockAdjustmentId ?? ""}
                />
            )}
        </div>
    );
};

export default EquipmentStockAdjustmentActivity;
